import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=0754d5e9"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"
import style0 from "./Produto.vue?vue&type=style&index=0&id=0754d5e9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports